// extracted by mini-css-extract-plugin
export default {"title":"Payment_title__DIKwS"};